import { render, staticRenderFns } from "./store1.vue?vue&type=template&id=638027ba&"
import script from "./store1.vue?vue&type=script&lang=js&"
export * from "./store1.vue?vue&type=script&lang=js&"
import style0 from "./store1.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports